/**
 * Item 5 (21/10): confirmação forte das exclusões de Plataforma, Workspace e Empresa. Quem exclui digita o nome; vale
 * qualquer um dos nomes dados (ex.: nome fantasia ou razão social), sem diferença de maiúscula, de espaço nas pontas
 * ou espaço repetido. A tela e a API usam a mesma regra.
 */
const normalizar = (s: string) => s.normalize('NFC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('pt-BR');

export function confirmaNome(digitado: string | null | undefined, ...nomes: (string | null | undefined)[]): boolean {
  const d = normalizar(digitado ?? '');
  return d !== '' && nomes.some((n) => !!n && normalizar(n) === d);
}
